var _defs, _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75,
    height: 46,
    viewBox: "0 0 75 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141",
    "data-name": "Rectangle 141",
    width: 41.146,
    height: 46
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(16.427 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M1.243,17.234l2.652-2.652a.317.317,0,0,0,.017-.447l-.695-.695a.38.38,0,0,0-.537.02L.121,16.02a.381.381,0,0,0-.02.537l.695.694a.317.317,0,0,0,.447-.017",
    transform: "translate(0 -2.835)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M1.585,19.1,5.732,14.95a.441.441,0,0,0-.624-.624L.961,18.473a.441.441,0,1,0,.624.624",
    transform: "translate(-0.177 -3.017)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M27.182,16.263a1.268,1.268,0,0,0,1.2-.5l2.625-3.55a1.269,1.269,0,0,0,.125-1.3l-.066-.14a1.27,1.27,0,0,0-2.075-.319L25.813,13.87a1.27,1.27,0,0,0-.152,1.53,1.769,1.769,0,0,0,1.251.824Z",
    transform: "translate(-5.413 -2.136)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M29.821,16.463a1.011,1.011,0,0,0,.071,1.332,2.014,2.014,0,0,0,1.573.6l.069,0a1.013,1.013,0,0,0,.831-.541l1.729-3.311a1.012,1.012,0,0,0,.057-.8l-.064-.182a1.012,1.012,0,0,0-1.749-.29Z",
    transform: "translate(-6.291 -2.737)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M21.1,10.5l1.591-1.625a11.855,11.855,0,0,1-.949-.967L20.51,6.424,18.5,8.268a1.214,1.214,0,0,0-.339,1.288l.117.265a2.127,2.127,0,0,0,.246.458A1.67,1.67,0,0,0,21.1,10.5",
    transform: "translate(-3.846 -1.365)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M24.234,14.014l3.037-3.187c-.241.175-.929.083-1.232.043a5.5,5.5,0,0,1-2.514-1.136l-1.751,1.9a1.689,1.689,0,0,0-.339,1.816l.019.046a1.689,1.689,0,0,0,2.779.521",
    transform: "translate(-4.527 -2.069)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M39.46.264a9.4,9.4,0,0,1-6.551.976L30.29.674a9.4,9.4,0,0,0-6.394.89l-2,.962a1.475,1.475,0,0,0-.763,1.785,1.538,1.538,0,0,0,.315.54l1.232,1.4a6.128,6.128,0,0,0,3.463,2.1.851.851,0,0,0,.953-.966l-.143-.995a2.074,2.074,0,0,0-.506-1L24.9,3.841a2.773,2.773,0,0,1-.2-.249,2.538,2.538,0,0,1-.165-.26,3.5,3.5,0,0,1-.19-.732,3.555,3.555,0,0,1-.035-.5,2.324,2.324,0,0,0,.991,1.419,7.291,7.291,0,0,1,1.373,1.189c.1-.344.078-.628.209-1a3.392,3.392,0,0,1,1.1-1.4,3.584,3.584,0,0,0-.591.943,3.71,3.71,0,0,0-.29,1.475,3.524,3.524,0,0,0,.065.638,3.594,3.594,0,0,1,.587,1.94c0,.4-.061.9-.061.9a12.42,12.42,0,0,1,1.377-.768,1.749,1.749,0,0,1,1.51,1l.067.139a1.747,1.747,0,0,1,.11,1.206,1.521,1.521,0,0,1,.331-.1,1.493,1.493,0,0,1,1.651.98l.064.181a1.519,1.519,0,0,1,.055.2l.008.3,2.095,1.846s1.281-.8,1.818-1.15A6.922,6.922,0,0,0,38.1,11a3.358,3.358,0,0,1,2.14-1.311l2.23-.376a8.175,8.175,0,0,0-.842-6.48L39.933,0Z",
    transform: "translate(-4.476 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M28.365,12.493,26.636,15.8a1.408,1.408,0,0,1-.13.2c.5.8-.085,1.724-.6,2.239a1.4,1.4,0,0,1-1.551.294L13.222,13.683a1.4,1.4,0,0,1-.815-1.549l1-3.915a1.4,1.4,0,0,1,1.244-1.13l2-1.831a1.835,1.835,0,0,1-.139-.319,1.872,1.872,0,0,1,.209-1.582l-.168-.127a3.942,3.942,0,0,0-6.226,2.077L7.443,11.161,1.557,17.047a1.789,1.789,0,0,0-.378,1.972l.661,1.533a71.689,71.689,0,0,0,15.7,23.657c2.213,2.213,6.889,3.3,9.1,1.089L40.153,31.785c2.213-2.213,1.124-6.889-1.089-9.1l-6.2-6.206q-2.14-2.14-4.438-4.112a1.233,1.233,0,0,1-.057.128M25.8,35.95a3.844,3.844,0,0,1-5.579-.146c-1.7-1.7-3.945-9.378-3.945-9.378,3.083,3.083,7.674,2.243,9.378,3.945A3.844,3.844,0,0,1,25.8,35.95",
    transform: "translate(-0.219 -0.51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M6.172,8.066l.261-.141A1.155,1.155,0,0,0,6.9,6.36l-1.8-3.332a1.155,1.155,0,0,0-1.566-.465l-.753.408a.454.454,0,0,0-.183.616L5.064,8.15a.454.454,0,0,0,.592.195c-.009.193-.012.387-.011.589.006,1.855.261,2.155.395,2.281.167.158.453.336.575.251.243-.169-.513-1.1-.463-2.512.01-.274.015-.512.02-.887",
    transform: "translate(-0.539 -0.515)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149",
    "data-name": "Rectangle 149",
    width: 75,
    height: 46,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOil);
export default __webpack_public_path__ + "static/media/oil.349454e13e5479eed60aedad3cbb07eb.svg";
export { ForwardRef as ReactComponent };